import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { injectIntl, FormattedMessage } from "react-intl";
import cx from "classnames";

class TextFieldCmp extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    autoComplete: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    className: PropTypes.string,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
      warning: PropTypes.string
    }),
    hidden: PropTypes.bool,
    disabled: PropTypes.bool,
    showValidation: PropTypes.bool
  };

  render() {
    const {
      input,
      label,
      meta: { touched, error, warning },
      id,
      showValidation,
      className,
      disabled
    } = this.props;

    return (
      <div className={cx("RadioField", className)}>
        <input {...input} type="radio" id={id} disabled={disabled} />
        <label htmlFor={id}>
          <span>
            <FormattedMessage id={label} />
          </span>
        </label>
        {showValidation &&
          touched &&
          ((error && (
            <span className="error">
              <FormattedMessage id={error} />
            </span>
          )) ||
            (warning && (
              <span>
                <FormattedMessage id={warning} />
              </span>
            )))}
      </div>
    );
  }
}

const TextField = props => (
  <Field component={TextFieldCmp} type="radio" {...props} />
);

export default injectIntl(TextField);



// WEBPACK FOOTER //
// ./src/modules/forms/fields/custom-radio-field.js